import { UPDATE_EBLAST } from '../../constants';

const initialState = {
  data: {},
  loading: false,
  error: {},
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case UPDATE_EBLAST.LOAD:
      return {
        ...state,
        loading: true,
      };
    case UPDATE_EBLAST.SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false,
      };
    case UPDATE_EBLAST.FAIL:
      return {
        ...state,
        error: payload,
        loading: true,
      };
    default:
      return state;
  }
}
